/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Dealname2Inputs */

const en_coinvestments_insights_col_dealname2 = /** @type {(inputs: Coinvestments_Insights_Col_Dealname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal name`)
};

/**
* | output |
* | --- |
* | "Deal name" |
*
* @param {Coinvestments_Insights_Col_Dealname2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_dealname2 = /** @type {((inputs?: Coinvestments_Insights_Col_Dealname2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Dealname2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_dealname2(inputs)
});
export { coinvestments_insights_col_dealname2 as "coInvestments_insights_col_dealName" }